import gql from "graphql-tag";

const CREATE_BATCH_APPROVAL = gql`
  mutation($input: BatchApprovalInput!) {
    createBatchApproval(input: $input) {
      id
    }
  }
`;
export default {
  data() {
    return {
      batchApproveTask: null,
      showBatchApproveTaskStatus: false,
    };
  },
  methods: {
    async batchApprove(list, name) {
      const input = {
        name,
        recordsIds: list.map((r) => (r.node ? r.node.id : r.id)),
        filter: JSON.stringify(this.searchParams),
      };
      try {
        const { data } = await this.$apollo.mutate({
          mutation: CREATE_BATCH_APPROVAL,
          variables: {
            input: { ...input },
          },
        });
        this.batchApproveTask = { ...data.createBatchApproval };
        this.showBatchApproveTaskStatus = true;
      } catch (error) {
        console.error(error);
      }
    },
    onBatchApproveComplete(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: result.taskStatus.notes,
        color: result.taskStatus.status == "ERROR" ? "error" : "success",
      });
      this.showBatchApproveTaskStatus = false;
      if (this.$apollo.queries.purchaseInvoices != null) {
        this.$apollo.queries.purchaseInvoices.refetch();
      }
      if (this.$apollo.queries.salesInvoices != null) {
        this.$apollo.queries.salesInvoices.refetch();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gt/finances/purchase-invoices/batch-approve-mixin.js